import { render, staticRenderFns } from "./ViewDialog.vue?vue&type=template&id=50b2ae02&scoped=true"
import script from "./ViewDialog.vue?vue&type=script&lang=js"
export * from "./ViewDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewDialog.vue?vue&type=style&index=0&id=50b2ae02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b2ae02",
  null
  
)

export default component.exports